import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class TrackingsService extends ApiService {
  entityType = EntityType.TRACKING;
  url = 'api/trackings/';
}
